import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Button from '@material-ui/core/Button'
import { withStyles } from '@material-ui/core/styles'

import Typography from '@material-ui/core/Typography'
import DashboardIcon from 'components/atoms/DashboardIcon'
import ArrowForwardIOS from '@material-ui/icons/ArrowForwardIos'

const styles = theme => ({
  container: {
    width: '100%',
    display: 'flex',
    borderRadius: 8,
    cursor: 'pointer',
    marginBottom: theme.spacing(2),
    justifyContent: 'space-between',
    boxShadow: '0px 0px 10px rgba(0,0,0,0.15)',
    '&:hover': {
      backgroundColor: theme.palette.background.light,
    },
  },
  content: {
    margin: 0,
    display: 'flex',
    alignItems: 'center',
  },
  image: {
    marginRight: theme.spacing(1),
  },
  label: {
    fontSize: 14,
    fontWeight: 400,
    textTransform: 'none',
  },
})

const ButtonWithImage = ({
  classes,
  text,
  image,
  className,
  data,
  onPress,
  ...other
}) => (
  <Button
    onClick={() => onPress(data)}
    classes={{ label: classes.label }}
    className={classNames(className, classes.container)}
    {...other}>
    <figure className={classes.content}>
      <DashboardIcon className={classes.image} data={image} />
      <Typography className={classes.label}>{text}</Typography>
    </figure>
    <ArrowForwardIOS color="primary" style={{ fontSize: 20 }} />
  </Button>
)

ButtonWithImage.propTypes = {
  text: PropTypes.string,
  data: PropTypes.object,
  onPress: PropTypes.func,
  image: PropTypes.string,
  classes: PropTypes.object,
  className: PropTypes.string,
}

export default withStyles(styles)(ButtonWithImage)



// WEBPACK FOOTER //
// ./src/components/atoms/buttons/ButtonWithImage.js